import {Injectable} from '@angular/core';
import { environment } from '../../../environments/environment';
// import * as _ from 'lodash';

@Injectable()

export class Logger {
  log(message: any) {
    if (!environment.production) {
        console.log(message);
    }
  }
}
